var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpitaLogoIngenieurCmjn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.453,
    height: 108,
    viewBox: "0 0 159.453 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}.b{fill:url(#b);}.c{clip-path:url(#e);}.d{fill:url(#f);}.e{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159.453,
    height: 108
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#005375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#00739f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#008bbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#009bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#00a5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a9e7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.464,
    height: 112.949
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#004f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#006891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#007dac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#008dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#0099d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#00a2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#00a7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a9e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M134.8,109.688,252.639,79.372,177.168,22.68Z",
    transform: "translate(-93.186 -15.678)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.078 -2.13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,50.129,82.136,108,77.468,0Z",
    transform: "translate(2.078 2.13)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.771 0.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.37,3.07l32.523,79.642H38.13Z",
    transform: "translate(-38.13 -3.07)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M183.449,115.9l4.683,12.166h-9.366Zm6.813,17.717,1.933,5.054h5.946L183.446,100.41l-14.719,38.259h5.946l1.957-5.054Zm-42.75-25.994h9.119v30.726h5.551V107.622H171.3v-5.748H147.512Zm-10.379,30.924h5.551V101.453h-5.551ZM116.514,107.3h.42a8.971,8.971,0,1,1,0,17.942h-.42Zm.423,23.444a14.46,14.46,0,1,0,0-28.92h-5.971v36.721h5.551v-7.8h.42Zm-29.757,7.8h16.9v-5.551H92.755v-9.913h11.324v-5.551H92.755v-9.913h11.324v-5.551H87.18Z",
    transform: "translate(-60.266 -69.412)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M198.1,235.908h-2.6v3.5h2.621v-.55h-2v-.938h1.753v-.55h-1.753v-.911H198.1Zm-3.553,0h-.614v2.016c0,.645-.336.975-.88.975s-.886-.349-.886-1v-1.991h-.614v2.016a1.38,1.38,0,0,0,1.491,1.54,1.4,1.4,0,0,0,1.5-1.571Zm-5.026,2.825a1.109,1.109,0,0,1-.6.17,1.2,1.2,0,0,1-1.189-1.25,1.184,1.184,0,0,1,1.179-1.241,1.264,1.264,0,0,1,1.009,1.911l-.605-.55-.4.451Zm.871,0a1.813,1.813,0,0,0,.355-1.08,1.829,1.829,0,1,0-1.834,1.815,1.833,1.833,0,0,0,1.065-.33l.42.374.4-.438Zm-4.816.676h.614v-3.5h-.614Zm-1.911-2.93h1.111v-.571h-2.84v.571h1.111v2.93h.621v-2.93Zm-2.973,1.537h-1.2l.6-1.4Zm-.312-2.133h-.571l-1.54,3.526h.63l.361-.846h1.655l.355.846h.651Zm-3.439,1.016v2.51h.614v-3.5H176.9l-1.065,1.655-1.065-1.655h-.654v3.5h.605v-2.5l1.1,1.639h.019Zm-4.319.154c0,.361-.281.59-.719.59H171v-1.176h.9c.454,0,.725.2.725.587m.735,2.356-.945-1.324a1.046,1.046,0,0,0,.834-1.065c0-.685-.494-1.111-1.3-1.111h-1.559v3.5H171V238.19h.769l.861,1.219Zm-4.476-1.747A1.184,1.184,0,0,1,167.7,238.9a1.2,1.2,0,0,1-1.192-1.25,1.184,1.184,0,0,1,1.179-1.241,1.2,1.2,0,0,1,1.192,1.25m.645-.009a1.829,1.829,0,1,0-1.834,1.815,1.778,1.778,0,0,0,1.834-1.815m-4.263-1.744h-2.606v3.5h.614v-1.426h1.766v-.559h-1.766v-.954h1.991Zm-4.226,2.42-1.874-2.42h-.571v3.5h.605v-2.491l1.929,2.491h.516v-3.5h-.605Zm-4.109,1.081h.614v-3.5h-.614Zm-3.251-1.081-1.874-2.42h-.571v3.5h.605v-2.491l1.929,2.491h.516v-3.5h-.605Zm-3.316-2.42h-2.6v3.5h2.621v-.55h-2v-.938h1.753v-.55H148.38v-.911h1.979Zm-6.986.914c0-.235.21-.42.571-.42a1.574,1.574,0,0,1,.951.361l.33-.466a1.942,1.942,0,0,0-1.269-.438,1.068,1.068,0,0,0-1.195,1.019c0,.651.42.871,1.164,1.05.651.151.79.284.79.54s-.241.445-.62.445a1.612,1.612,0,0,1-1.105-.454l-.37.438a2.164,2.164,0,0,0,1.46.559c.735,0,1.25-.389,1.25-1.05,0-.583-.386-.849-1.124-1.031-.673-.157-.834-.278-.834-.553m-2.013.232c0,.361-.281.59-.719.59h-.9v-1.176h.9c.454,0,.725.2.725.587m.735,2.356-.945-1.324a1.046,1.046,0,0,0,.834-1.065c0-.685-.494-1.111-1.3-1.111h-1.559v3.5h.614V238.19h.769l.861,1.219Zm-3.93-3.5h-.614v2.016c0,.645-.336.975-.88.975s-.886-.349-.886-1v-1.991h-.614v2.016a1.38,1.38,0,0,0,1.491,1.54,1.4,1.4,0,0,0,1.5-1.571Zm-3.809,0h-2.6v3.5h2.621v-.55h-2v-.938h1.753v-.55h-1.753v-.911h1.979Zm-4.26,3.5h.614v-3.5h-.614Zm-1.655-1.081-1.874-2.42H126v3.5h.605v-2.491l1.929,2.491h.516v-3.5h-.605Zm-4.5-2.711.611-.574L124,234.8l-.531.821h.469Zm1.189.29h-2.6v3.5h2.621v-.55h-2v-.938H124.9v-.55h-1.753v-.911h1.979Zm-3.51,3.016v-1.469h-1.491v.534h.9v.655a1.43,1.43,0,0,1-.846.265,1.169,1.169,0,0,1-1.189-1.253,1.184,1.184,0,0,1,1.136-1.241,1.372,1.372,0,0,1,.979.374l.389-.466a1.89,1.89,0,0,0-1.346-.475,1.785,1.785,0,0,0-1.806,1.815,1.738,1.738,0,0,0,1.815,1.806,2.243,2.243,0,0,0,1.463-.543m-4.739-.6L115,235.908h-.571v3.5h.605v-2.491l1.929,2.491h.516v-3.5h-.605Zm-4.112,1.081h.614v-3.5h-.614Zm-1.747-2.346.065.259a.727.727,0,0,0,.769-.83v-.587h-.664v.685h.256c.022.262-.123.417-.426.472m-1.25.6a1.143,1.143,0,0,1-1.216,1.185h-.692v-2.38h.692a1.152,1.152,0,0,1,1.216,1.195m.645-.009a1.744,1.744,0,0,0-1.858-1.744h-1.306v3.5h1.306a1.755,1.755,0,0,0,1.858-1.757m-5.631-1.744h-2.6v3.5h2.621v-.55h-2v-.938h1.754v-.55H102.8v-.911h1.979Zm-5.807,3.5h2.454v-.559h-1.84v-2.939h-.614Zm-1.5-1.747a1.184,1.184,0,0,1-1.179,1.241,1.2,1.2,0,0,1-1.189-1.25,1.184,1.184,0,0,1,1.179-1.241,1.2,1.2,0,0,1,1.189,1.25m.645-.009a1.829,1.829,0,1,0-1.834,1.815,1.778,1.778,0,0,0,1.834-1.815m-4.165,1.195-.4-.4a1.366,1.366,0,0,1-1.006.454,1.249,1.249,0,0,1,0-2.491,1.386,1.386,0,0,1,.979.435l.4-.454a1.825,1.825,0,0,0-1.371-.546,1.811,1.811,0,0,0-.025,3.621,1.8,1.8,0,0,0,1.423-.617m-5.106-3.229.611-.574-.55-.244-.531.821h.469Zm1.192.29h-2.6v3.5h2.621v-.55h-2v-.938h1.753v-.55H88.057v-.911h1.979Z",
    transform: "translate(-60.446 -162.314)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpitaLogoIngenieurCmjn);
export default __webpack_public_path__ + "static/media/EPITA_LOGO_INGENIEUR_CMJN.b1c7cf53347515e8c23614a3446a4b63.svg";
export { ForwardRef as ReactComponent };